"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function ReadyIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#7CAF1F", d: "M16,8 C16,12.4181333 12.4192,16 8,16 C3.5808,16 0,12.4181333 0,8 C0,3.58186667 3.5808,0 8,0 C12.4192,0 16,3.58186667 16,8" }),
            React.createElement("polyline", { stroke: "#FFF", strokeWidth: "2", points: "3.981 6.6 7.181 9.8 11.981 5" }))));
}
exports.ReadyIcon = ReadyIcon;
